//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttendanceStatus, MakeUpUnavailableReason } from './Enums';

export class AttendanceOptionDisplayItem extends ItemBase {
    Status: AttendanceStatus = AttendanceStatus.Unrecorded;
    Enabled: boolean = false;
    IsAbsent: boolean = false;
    IsPresent: boolean = false;
    IsBillable: boolean = false;
    UsesMakeUpCredit: boolean = false;
    IssuesMakeUpCredit: boolean = false;
    CanOverrideAttendanceFee: boolean = false;
    MakeUpUnavailableReason: MakeUpUnavailableReason = MakeUpUnavailableReason.None;

    constructor(initializer?: Partial<AttendanceOptionDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceOptionDisplayItem";
}
